
import Http from './Http'

export default {
    async getNotifications(page=1,limit=100, filters = '') {
        return await Http.get(`/notification?page=${page}&limit=${limit}`+filters)
    },
    async getNotificationSetup() {
        return await Http.get(`/notification/setup`)
    },
    async getDeviceNotification(page=1,limit=100, filters = '') {
        return await Http.get(`/notification/device?page=${page}&limit=${limit}`+filters)
    },
    async getNotificationTypes(data) {
        return await Http.get(`/notification/types?${data}`)
    },
    async create(data) {
        const isFormData =
          typeof FormData !== "undefined" && data instanceof FormData;
        if (isFormData) {
          return await Http.post(`/notification/create`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        return await Http.post(`/notification/create`, data);
    },
    async deleteNotification(notification_group_id) {
        return await Http.delete(`notification/${notification_group_id}`)
    },
    async getNotificationByGroup(notification_group_id) {
        return await Http.get(`notification/${notification_group_id}`)
    },
    async getNotificationRecipients(notification_id  ) {
        return await Http.get(`/notification/devices_tokens/${notification_id}`)
    },
    async exportNotificationRecipients(notification_id ) {
        return await Http.get(`/notification/export_devices_tokens/${notification_id}`)
    },
    async getAutoNotifications() {
        return await Http.get(`/notification/automated_notification`)
    },
    async getTypeNotification() {
        return await Http.get(`/notification/automated_notification_types`)
    },
    async createAutomatedNotification(data) {
        return await Http.post(`/notification/add_automated_notification`,data)
    },
    async updateAutomatedNotification(data,type) {
        return await Http.post(`/notification/update_automated_notification/${type}`,data)
    },
    async getAutomatedNotificationTypes() {
        return await Http.get(`/notification/automated/types`)
    },
    async getAutomatedNotification(data) {
        return await Http.get(`/notification/automated_setup?${data}`)
    },
    async createNotificationSetup(data) {
        return await Http.post(`/notification/automated_setup`,data)
    },
    async deleteNotificationSetup(id) {
        return await Http.delete(`/notification/automated_setup/${id}`)
    },
    async getNotificationTopics(token_id) {
        return await Http.get(`/notification/token/${token_id}/topics`)
    },
    async getNotificationsTopic() {
        return await Http.get(`/notification/topics`)
    },
    async getNotificationsTopicSubscriptions(topic) {
        return await Http.get(`/notification/topics/${topic}/subscriptions`)
    },
    async getPushNotifications() {
        return await Http.get(`/notification/basic`)
    },

    async getAudience(recipient, filters = '') {
        return await Http.get(`/notification/${recipient}/audience?${filters}`)
    },

    async createNotificationType(data) {
        return await Http.post(`/notification/types`, data)
    },
    async deleteNotificationType(team_id, type_code) {
        return await Http.delete(`/notification/types/${team_id}/${type_code}`)
    },
    // Notifications setup
    async getNotificationTypesSetup() {
        return await Http.get(`/notification/types/setup`)
    },

    async deleteNotificationTypeSetup(type_code){
        return await Http.delete(`/notification/types/setup/${type_code}`)
    },

    async updateNotificationType(team_id, type_code, data) {
        return await Http.patch(`/notification/types/${team_id}/${type_code}`, data)
    },

    async reorderNotificationTypes(data) {
        return await Http.patch(`/notification/types/reorder`, data)
    },

    async createNotificationTypeSetup(data){
        return await Http.post(`/notification/types/setup`,data)
    },

    async createAutomatedSchedule(data) {
        const isFormData =
          typeof FormData !== "undefined" && data instanceof FormData;
        if (isFormData) {
          return await Http.post(`/notification/automated_schedule`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        return await Http.post(`/notification/automated_schedule`, data);
    },

}


